import { useSearchParams } from "react-router-dom";
import { TenantFilterValues } from "./tenants-filter.types";
import { useMemo } from "react";
import { ApplicationType } from "@libs/api/gateways/plt/plt-gateway.dtos";

export const useTenantsFilterSearchParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const initialValues: TenantFilterValues = useMemo(() => {
    const name = searchParams.get("name") ?? "";
    const tenantId = searchParams.get("tenantId") ?? "";
    const crmId = searchParams.get("crmId") ?? "";
    const applications = (searchParams.getAll("applications") ??
      []) as ApplicationType[];

    const isInactive = (searchParams.get("isInactive") ?? false) as boolean;

    return { name, tenantId, crmId, isInactive, applications };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { initialValues, setSearchParams };
};
